import { lazy } from 'react'

/**
 * The Agent's run history, for the Tasks screen's second tab.
 *
 * Lazy for the reason the module is: it brings the Agent's providers and
 * stylesheets, and somebody who never opens the tab never downloads them.
 */
export const AgentRuns = lazy(() => import('@/client/runs'))
